import { showSuccessAlert, showErrorAlert } from '../utils/sweetAlertConfig';

export const repharsePrompt = async (prompt, setPrompt, setIsRephrasing) => {
    if (!prompt.trim()) {
        showErrorAlert('Please enter a prompt to rephrase', 'Empty Prompt');
        return;
    }

    setIsRephrasing(true);
    try {
        const response = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${process.env.REACT_APP_CHATGPT_API_KEY}`,
            },
            body: JSON.stringify({
                model: "gpt-3.5-turbo", 
                messages: [
                    {
                        role: "system",
                        content: "You are an AI prompt-writing assistant for Shutter Labs, an AI Image generation platform that creates photorealistic lifestyle images for furniture brands. Your job is to write image prompts for the FLUX Kontext model. Always follow these principles. Keep the prompt under 50 words.  Do not define the visual style, it comes from the user.  Focus on describing the scene composition, furniture placement,  lighting. Every furniture item should be placed logically, with clear orientation and position in the room. The room layout must make sense, as if ready for a magazine or website. Add keywords to make it high quality and high definition, do not describe any furniture, give response upto 40 words"
                    },
                    {
                        role: "user", 
                        content: `Enhance the prompt: "${prompt}". Focus on making the image more beautiful by improving the composition and overall appearance. do not describe any furniture, always start the prompt with 'Product in..`
                    }
                ],
                max_tokens: 50,
                temperature: 0.8,
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.choices && data.choices[0]?.message?.content) {
            setPrompt(data.choices[0].message.content);
        } else {
            throw new Error('Invalid response from rephrase service');
        }
    } catch (error) {
        console.error('Error rephrasing prompt:', error);
        showErrorAlert('Failed to rephrase prompt. Please try again.');
    } finally {
        setIsRephrasing(false);
    }
};
